import React, { useMemo } from 'react'
import { buildRoomPackageOptionsViewOrder, filterPackageOptionsBySkiPackageType } from 'lib/offer/offerPageUtil'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getCheapestSelectedPackageOption, getDurationPackageOptions, OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import AccommodationRoomTile from 'components/AccommodationKit/AccommodationRoomTile'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import FlashHotelAboutRoomModalTab from './FlashHotelAboutRoomModalTab'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import ModalBase from 'components/Luxkit/Modal/ModalBase'

interface Props {
  room: App.PackageRoomType;
  packageOptions: Array<OfferPackageOptionView>;
  onClose?: () => void;
  cheapestSelectedOption?: OfferPackageOptionView;
}

function FlashHotelRoomDetailsModal(props: Props) {
  const {
    room,
    packageOptions: basePackageOptions,
    cheapestSelectedOption,
  } = props

  // TEMP: Remove this logic when "006RF00000IRdvlYAD" becomes unavailable
  const { packageOptions } = useMemo(() => {
    return filterPackageOptionsBySkiPackageType(basePackageOptions, cheapestSelectedOption)
  }, [basePackageOptions, cheapestSelectedOption])

  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  const packageViews = packageOptionsByRoom.find(option => option.roomId === room.id)?.packageViews
  const pkg = packageViews?.[0].package!

  return (
    <ModalBase mode="drawer">
      <ModalHeader
        title={room.name}
      />
      <ModalBody>
        <AccommodationRoomTile roomPackage={pkg}>
          <AccommodationRoomTileImage
            roomPackage={pkg}
          />
        </AccommodationRoomTile>
        <ModalContent>
          <FlashHotelAboutRoomModalTab pkg={pkg} />
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  cheapestSelectedOption: getCheapestSelectedPackageOption(appState, state),
  packageOptions: getDurationPackageOptions(state, appState),
}), FlashHotelRoomDetailsModal)
